"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var classnames_1 = require("classnames");
var CustomerSubscriptionListPage_1 = require("./CustomerSubscriptionListPage");
var CustomerProfilePage_1 = require("./CustomerProfilePage");
var MonthlyStatementPage_1 = require("./MonthlyStatementPage");
require("../../styles/CustomerDetailPage.css");
var msal_react_1 = require("@azure/msal-react");
var msal_browser_1 = require("@azure/msal-browser");
var authConfig_1 = require("../../authConfig");
var react_1 = require("react");
var CustomerUserPage_1 = require("./CustomerUserPage");
var AuditLogPage_1 = require("./AuditLogPage");
var CustomerDetailPage = function (props) {
    var authRequest = __assign({}, authConfig_1.loginRequest);
    var inProgress = (0, msal_react_1.useMsal)().inProgress;
    var _a = React.useState('CustomerProfilePage'), activeTab = _a[0], setActiveTab = _a[1]; //useState('CustomerProfile');
    var companyId = parseInt(props.match.params.id, 10) || 0;
    var toggle = function (tab) {
        if (activeTab !== tab)
            setActiveTab(tab);
    };
    (0, react_1.useEffect)(function () {
    }, [inProgress]);
    return (React.createElement(React.Fragment, null,
        React.createElement(msal_react_1.MsalAuthenticationTemplate, { interactionType: msal_browser_1.InteractionType.Redirect, authenticationRequest: authRequest },
            React.createElement("div", { className: "CustomerDetailPageHeader" },
                React.createElement("div", null,
                    React.createElement("h5", { className: "card-title" }, "List of Customers"))),
            React.createElement("div", { id: "company-profile" },
                React.createElement(reactstrap_1.Nav, { tabs: true },
                    React.createElement(reactstrap_1.NavItem, null,
                        React.createElement(reactstrap_1.NavLink, { className: (0, classnames_1.default)({ active: activeTab === 'CustomerProfilePage' }), onClick: function () { toggle('CustomerProfilePage'); } }, "Customer Profile")),
                    React.createElement(reactstrap_1.NavItem, null,
                        React.createElement(reactstrap_1.NavLink, { className: (0, classnames_1.default)({ active: activeTab === 'SubscriptionPage' }), onClick: function () { toggle('SubscriptionPage'); } }, "Subscriptions")),
                    React.createElement(reactstrap_1.NavItem, null,
                        React.createElement(reactstrap_1.NavLink, { className: (0, classnames_1.default)({ active: activeTab === 'UserPage' }), onClick: function () { toggle('UserPage'); } }, "User")),
                    React.createElement(reactstrap_1.NavItem, null,
                        React.createElement(reactstrap_1.NavLink, { className: (0, classnames_1.default)({ active: activeTab === 'MonthlyStatementPage' }), onClick: function () { toggle('MonthlyStatementPage'); } }, "Monthly Statement")),
                    React.createElement(reactstrap_1.NavItem, null,
                        React.createElement(reactstrap_1.NavLink, { className: (0, classnames_1.default)({ active: activeTab === 'AuditLogsPage' }), onClick: function () { toggle('AuditLogsPage'); } }, "Audit Logs"))),
                React.createElement(reactstrap_1.TabContent, { activeTab: activeTab },
                    React.createElement(reactstrap_1.TabPane, { tabId: "CustomerProfilePage" },
                        React.createElement(reactstrap_1.Row, null,
                            React.createElement(reactstrap_1.Col, { sm: "12" },
                                React.createElement(CustomerProfilePage_1.default, { id: companyId })))),
                    React.createElement(reactstrap_1.TabPane, { tabId: "SubscriptionPage" },
                        React.createElement(reactstrap_1.Row, null,
                            React.createElement(reactstrap_1.Col, { sm: "12" },
                                React.createElement(CustomerSubscriptionListPage_1.default, { id: companyId })))),
                    React.createElement(reactstrap_1.TabPane, { tabId: "UserPage" },
                        React.createElement(reactstrap_1.Row, null,
                            React.createElement(reactstrap_1.Col, { sm: "12" },
                                React.createElement(CustomerUserPage_1.default, { id: companyId })))),
                    React.createElement(reactstrap_1.TabPane, { tabId: "MonthlyStatementPage" },
                        React.createElement(reactstrap_1.Row, null,
                            React.createElement(reactstrap_1.Col, { sm: "12" },
                                React.createElement(MonthlyStatementPage_1.default, { companyId: companyId })))),
                    React.createElement(reactstrap_1.TabPane, { tabId: "AuditLogsPage" },
                        React.createElement(reactstrap_1.Row, null,
                            React.createElement(reactstrap_1.Col, { sm: "12" },
                                React.createElement(AuditLogPage_1.default, { companyId: companyId })))))))));
};
exports.default = CustomerDetailPage;
//# sourceMappingURL=CustomerDetailPage.js.map